import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export const SearchOptions = {
    Member: 'Member',
    Prescriber: 'Prescriber',
    IntakeCase: 'Intake Case',
} as const;
export type SearchOption = (typeof SearchOptions)[keyof typeof SearchOptions];

export interface ArchivedIntakeCaseSliceState {
    searchParams?: {
        searchOption?: SearchOption;
        memberId?: string;
        memberFirstName?: string;
        memberLastName?: string;
        prescriberNpi?: string;
        intakeCaseId?: string;
    };
}

const initialState: ArchivedIntakeCaseSliceState = {};

export const archivedIntakeCaseSlice = createSlice({
    name: 'archivedIntakeCases',
    initialState,
    reducers: {
        setArchivedIntakeCaseSearch(
            state,
            action: PayloadAction<{
                searchParams: Required<ArchivedIntakeCaseSliceState>['searchParams'];
            }>,
        ) {
            const { searchParams } = action.payload;
            return { ...state, searchParams };
        },
        clearArchivedIntakeCaseSearch(state) {
            return { ...state, searchParams: undefined };
        },
    },
});

export const { setArchivedIntakeCaseSearch, clearArchivedIntakeCaseSearch } =
    archivedIntakeCaseSlice.actions;
